import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './locales/es.json'
import en from './locales/en.json'

// Detectar idioma guardado o del navegador
const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('casino_language')
  if (saved && ['es', 'en'].includes(saved)) {
    return saved
  }
  // Detectar del navegador
  const browserLang = navigator.language.split('-')[0]
  return ['es', 'en'].includes(browserLang) ? browserLang : 'es'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
    react: {
      useSuspense: false,
    },
  })

// Guardar idioma cuando cambie
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('casino_language', lng)
  document.documentElement.lang = lng
})

export default i18n
